import { forwardRef } from 'react';
import { Avatar } from 'avatar-components/Avatar';
import PortalIdParser from 'PortalIdParser';
import { CONTACT, COMPANY, USER } from '../../constants/CallParticipantTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const getUIAvatar = ({
  objectId,
  email,
  displayName,
  objectType,
  size = 'responsive',
  dataTestId = 'avatarWrapper',
  onClick
}) => {
  const portalId = PortalIdParser.get();
  switch (objectType) {
    case USER:
      return /*#__PURE__*/_jsx(Avatar, {
        hubSpotUserEmail: email !== null && email !== void 0 ? email : undefined,
        displayName: displayName !== null && displayName !== void 0 ? displayName : undefined,
        size: size,
        "data-test-id": dataTestId,
        onClick: onClick
      });
    case CONTACT:
      return /*#__PURE__*/_jsx(Avatar, {
        vid: objectId !== null && objectId !== void 0 ? objectId : undefined,
        email: email !== null && email !== void 0 ? email : undefined,
        displayName: displayName !== null && displayName !== void 0 ? displayName : undefined,
        size: size,
        portalId: portalId,
        "data-test-id": dataTestId,
        onClick: onClick
      });
    case COMPANY:
      return /*#__PURE__*/_jsx(Avatar, {
        companyId: objectId !== null && objectId !== void 0 ? objectId : undefined,
        displayName: displayName !== null && displayName !== void 0 ? displayName : undefined,
        size: size,
        portalId: portalId,
        "data-test-id": dataTestId,
        onClick: onClick
      });
    default:
      return /*#__PURE__*/_jsx(Avatar, {
        vid: undefined,
        displayName: displayName !== null && displayName !== void 0 ? displayName : undefined,
        email: email !== null && email !== void 0 ? email : undefined,
        size: size,
        portalId: portalId,
        "data-test-id": dataTestId,
        onClick: onClick
      });
  }
};
export const AvatarWrapper = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    "data-test-id": "avatar-wrapper",
    children: getUIAvatar(props)
  });
});